import React from 'react';

const PrsLinks = () => {
  const { statements, setListHub } = window.mobile.config.urls;
  const { olsEnabled, slhEnabled } = window.mobile.userOptions;
  const { homepageLinksEnabled } = window.mobile.features;

  return (
    <React.Fragment>
      {olsEnabled && homepageLinksEnabled && (
        <a href={statements} rel="noopener noreferrer">
          <div>
            <span className="prs-icon prs-icon-statements" />
            <p>My statements</p>
          </div>
        </a>
      )}
      {slhEnabled && homepageLinksEnabled && (
        <a href={setListHub} rel="noopener noreferrer">
          <div>
            <span className="prs-icon prs-icon-setlisthub" />
            <p>Report performance</p>
          </div>
        </a>
      )}
    </React.Fragment>
  );
};

export default PrsLinks;
